import { Eyebrow, MaskedLines, Reveal } from "./Reveal";

export const PageHero = ({ eyebrow, lines, highlight, description }) => (
    <section className="relative overflow-hidden bg-mist pb-16 pt-32 md:pb-24 md:pt-44">
        <div
            className="pointer-events-none absolute -right-32 -top-32 h-[26rem] w-[26rem] rounded-full opacity-60 blur-3xl"
            style={{ background: "radial-gradient(circle, rgba(114,207,196,0.55) 0%, transparent 70%)" }}
        />
        <div
            className="pointer-events-none absolute -left-32 bottom-0 h-80 w-80 rounded-full opacity-50 blur-3xl"
            style={{ background: "radial-gradient(circle, rgba(244,168,150,0.45) 0%, transparent 70%)" }}
        />
        <div className="relative mx-auto max-w-4xl px-6 text-center">
            <Reveal>
                <Eyebrow>{eyebrow}</Eyebrow>
            </Reveal>
            <h1 className="mt-6 font-jakarta text-4xl font-extrabold leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-6xl">
                <MaskedLines lines={lines} delay={0.1} />
                {highlight && (
                    <span className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
                        <span className="mt-1 inline-block text-teal">{highlight}</span>
                    </span>
                )}
            </h1>
            {description && (
                <Reveal delay={0.35}>
                    <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-ink/70 md:text-lg">
                        {description}
                    </p>
                </Reveal>
            )}
        </div>
    </section>
);
